import ImageInput from './image-input';

export default ImageInput;
